import React from "react";
import { PawPrint } from "lucide-react";

// Fixed background paws that fill the empty left/right margins on desktop.
// Hidden on mobile (app panel fills the screen there).
const LEFT = [
  { top: "8%", left: "6%", size: 40, rot: -18, delay: 0.0, dur: 4.4, max: 0.34 },
  { top: "20%", left: "14%", size: 30, rot: 20, delay: 1.3, dur: 5.0, max: 0.28 },
  { top: "33%", left: "4%", size: 44, rot: -28, delay: 2.4, dur: 4.6, max: 0.32 },
  { top: "46%", left: "12%", size: 32, rot: 10, delay: 0.7, dur: 5.2, max: 0.28 },
  { top: "58%", left: "5%", size: 38, rot: -14, delay: 3.0, dur: 4.4, max: 0.34 },
  { top: "70%", left: "13%", size: 30, rot: 24, delay: 1.6, dur: 5.0, max: 0.26 },
  { top: "82%", left: "6%", size: 42, rot: -22, delay: 0.4, dur: 4.8, max: 0.32 },
  { top: "92%", left: "15%", size: 30, rot: 12, delay: 2.7, dur: 5.2, max: 0.26 },
];
const RIGHT = [
  { top: "10%", left: "88%", size: 42, rot: 18, delay: 0.6, dur: 4.6, max: 0.34 },
  { top: "22%", left: "95%", size: 30, rot: -20, delay: 2.0, dur: 5.0, max: 0.26 },
  { top: "35%", left: "86%", size: 38, rot: 26, delay: 0.9, dur: 4.4, max: 0.32 },
  { top: "48%", left: "94%", size: 32, rot: -12, delay: 3.1, dur: 5.2, max: 0.28 },
  { top: "60%", left: "87%", size: 44, rot: 16, delay: 1.1, dur: 4.6, max: 0.34 },
  { top: "72%", left: "95%", size: 30, rot: -26, delay: 2.5, dur: 5.0, max: 0.26 },
  { top: "84%", left: "86%", size: 40, rot: 22, delay: 0.2, dur: 4.8, max: 0.32 },
  { top: "94%", left: "93%", size: 30, rot: -16, delay: 3.4, dur: 5.2, max: 0.28 },
];

const ALL = [...LEFT, ...RIGHT];

export default function SidePaws() {
  return (
    <div className="side-paws" aria-hidden="true">
      {ALL.map((p, i) => (
        <PawPrint
          key={i}
          className="paw"
          fill="currentColor"
          style={{
            top: p.top,
            left: p.left,
            width: p.size,
            height: p.size,
            "--rot": `${p.rot}deg`,
            "--delay": `${p.delay}s`,
            "--dur": `${p.dur}s`,
            "--paw-max": p.max,
          }}
        />
      ))}
    </div>
  );
}
